module.exports = require("vtk.js/Sources/Interaction/Manipulators/MouseCameraTrackballPanManipulator");